import { logCustomMessage } from '@shared/easyfy.logger';
import PriceHelper from '@clientShared/priceHelper';
import TranslatorService from '@clientWebServices/translator.service';
import { globalEvent } from '@shared/easyfy.core';

export const registerChangeQuantityEvents = () => {
  globalEvent({
    type: 'click',
    events: [
      {
        event: 'decrease-quantity',
        callback: async () => await changeQuantity('decrease'),
      },
      {
        event: 'increase-quantity',
        callback: async () => await changeQuantity('increase'),
      },
    ],
  });

  globalEvent({
    type: 'change',
    event: {
      event: 'set-quantity',
      callback: async () => await changeQuantity('set'),
    },
  });
};

type QuantityAction = 'increase' | 'decrease' | 'set';

export const changeQuantity = async (action: QuantityAction) => {
  const parentContainer = document.querySelector('[data-container="page"]');
  const quantityInput = parentContainer?.querySelector<HTMLInputElement>('#quantity');
  const priceElement = parentContainer?.querySelector<HTMLElement>('[data-container="current-salesunit-info"] [data-container="selected-price"]');
  const price = priceElement?.getAttribute('data-sales-price') ?? '0';
  const unitPrice = parseFloat(price.replace(',', '.'));

  if (!quantityInput || !priceElement || isNaN(unitPrice)) {
    logCustomMessage('Error changing quantity.');
    return;
  }

  switch (action) {
    case 'increase':
      quantityInput.stepUp();
      break;
    case 'decrease':
      quantityInput.stepDown();
      break;
  }

  await validateQuantity(quantityInput);

  updatePrice(priceElement, unitPrice, quantityInput);
};

const updatePrice = (priceElement: HTMLElement, unitPrice: number, quantityInput: HTMLInputElement) => {
  const locale = document.documentElement.getAttribute('data-culture');
  if (!locale) return;

  if (!priceElement.textContent) return;

  const newPrice = PriceHelper.updateAndFormatPrice(priceElement.textContent, unitPrice * +quantityInput.value, locale);
  if (newPrice) {
    priceElement.textContent = newPrice;
  }
};

const validateQuantity = async (quantityInput: HTMLInputElement) => {
  const currentValue = +quantityInput.value;
  const maxValue = +quantityInput.max;

  if (Number.isNaN(currentValue) || !Number.isFinite(currentValue) || currentValue < 1) {
    quantityInput.value = quantityInput.min;
  }

  if (currentValue >= maxValue) {
    quantityInput.value = quantityInput.max;
    await showMaxQtyReachedText();
    return;
  }

  if (maxQtyElementExists()) {
    maxQtyElement()?.remove();
  }
};

const showMaxQtyReachedText = async () => {
  const singleQtyElement = document.querySelector<HTMLElement>('[data-container="product-quantity"]');
  if (!singleQtyElement) return;

  if (maxQtyElementExists()) return;

  const translator = TranslatorService.getInstance();
  const maxQtyReachedText = await translator.translate('pdp_max_qty_reached');

  const maxQtyReachedTextEl = document.createElement('div');
  maxQtyReachedTextEl.id = maxQtyId;
  maxQtyReachedTextEl.innerHTML = maxQtyReachedText;
  singleQtyElement.parentElement?.insertBefore(maxQtyReachedTextEl, singleQtyElement.nextSibling);
};

const maxQtyElementExists = (): boolean => {
  return maxQtyElement() !== null;
};

const maxQtyElement = () => document.querySelector<HTMLElement>(`#${maxQtyId}`);

const maxQtyId = 'maxQtyReached';
